var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarimg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.977,
    height: 28.983,
    viewBox: "0 0 28.977 28.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "call-_190_",
    "data-name": "call-[#190]",
    d: "M151.266,7167.984l-3.48-.03a.707.707,0,0,1-.494-1.218l5.261-5.26a1.452,1.452,0,0,0-2.049-2.058l-5.264,5.276a.747.747,0,0,1-1.253-.538l-.009-3.462a1.5,1.5,0,0,0-1.481-1.479,1.453,1.453,0,0,0-1.436,1.464l.006,7.259a2.906,2.906,0,0,0,2.9,2.9c1.129,0-.071,0,7.257.014a1.45,1.45,0,0,0,1.463-1.435,1.407,1.407,0,0,0-1.423-1.433m-6.814,13.59a31.929,31.929,0,0,0-3.079-1.6c-2.034-.825-1.9,1.624-3.351,2.42-2.063,1.131-8.777-5.4-8.474-7.448.235-1.564,2.094-1.636,1.562-3.565-.284-1.028-.792-2.04-1.174-3.026-.511-1.333-.72-2.188-2.21-2.114a3.093,3.093,0,0,0-2.449,1.377c-1.786,2.33-1.517,5.475-.316,8.025,3.373,7.172,10.255,11.866,15.2,12.316,1.878.16,4.5-.855,5.177-2.884-.046.13-.093.275-.114.334.017-.044.052-.146.114-.334.068-.218.1-.319.117-.361-.02.057-.067.2-.116.348.591-1.8.662-2.652-.891-3.492m.775,3.839c-.017.058-.014.058,0,0m.232-.7c.01-.029.012-.029,0,0",
    transform: "translate(-124 -7158.997)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarimg3);
export default __webpack_public_path__ + "static/media/sidebarimg3.2077ad65817b776d292e3fb2324ea034.svg";
export { ForwardRef as ReactComponent };